import {
  ORA_FAMILLE_SEARCH_ECHEC,
  ORA_FAMILLE_SEARCH_SUCCES,
  ORA_FAMILLE_SEARCH_REQUETTE,
  ORA_FAMILLE_SEARCH_RESET,
  ORA_ARTICLE_FAMILLE_REQUETTE,
  ORA_ARTICLE_FAMILLE_SUCCES,
  ORA_ARTICLE_FAMILLE_ECHEC,
} from "../constantes/oracleConstantes";
export const oraFamilleSearchReducer = (
  state = { familles: [], loading: false },
  action
) => {
  switch (action.type) {
    case ORA_FAMILLE_SEARCH_REQUETTE:
      return { loading: true };
    case ORA_FAMILLE_SEARCH_SUCCES:
      return { familles: action.payload, loading: false };
    case ORA_FAMILLE_SEARCH_ECHEC:
      return { erreur: action.payload, loading: false };
    case ORA_FAMILLE_SEARCH_RESET:
      return { familles: [], loading: false };
    default:
      return state;
  }
};

export const oraArticleFamilleReducer = (
  state = { articlesF: [], loading: false },
  action
) => {
  switch (action.type) {
    case ORA_ARTICLE_FAMILLE_REQUETTE:
      return { loading: true };
    case ORA_ARTICLE_FAMILLE_SUCCES:
      return { articlesF: action.payload, loading: false };
    case ORA_ARTICLE_FAMILLE_ECHEC:
      return { erreur: action.payload, loading: false };

    default:
      return state;
  }
};
